import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { ToastContainer } from './components/Toast';
import { ProtectedRoute } from './components/ProtectedRoute';
import { MainLayout } from './components/MainLayout';
import { KanbanBoard } from './components/KanbanBoard';
import { EventsManager } from './components/EventsManager';
import { CalendarView } from './components/CalendarView';
import { Login } from './pages/Login';
import { Settings } from './pages/Settings';
import { APIDocumentation } from './pages/APIDocumentation';

// Dashboard page with Kanban board
const Dashboard = () => (
  <MainLayout>
    <KanbanBoard />
  </MainLayout>
);

// Placeholder for Leads page
const Leads = () => (
  <MainLayout>
    <div className="text-center py-12">
      <h1 className="text-3xl font-bold text-gray-900 mb-4">All Leads</h1>
      <p className="text-gray-600">List view will be implemented here</p>
    </div>
  </MainLayout>
);

// Events page
const Events = () => (
  <MainLayout>
    <EventsManager />
  </MainLayout>
);

// Calendar page
const Calendar = () => (
  <MainLayout>
    <CalendarView />
  </MainLayout>
);

// API Documentation page
const APIDocs = () => (
  <MainLayout>
    <APIDocumentation />
  </MainLayout>
);

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <AuthProvider>
          <ToastProvider>
            <ToastContainer />
            <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/leads"
              element={
                <ProtectedRoute>
                  <Leads />
                </ProtectedRoute>
              }
            />
            <Route
              path="/events"
              element={
                <ProtectedRoute>
                  <Events />
                </ProtectedRoute>
              }
            />
            <Route
              path="/calendar"
              element={
                <ProtectedRoute>
                  <Calendar />
                </ProtectedRoute>
              }
            />
            <Route
              path="/settings"
              element={
                <ProtectedRoute>
                  <Settings />
                </ProtectedRoute>
              }
            />
            <Route
              path="/api-docs"
              element={
                <ProtectedRoute>
                  <APIDocs />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          </ToastProvider>
        </AuthProvider>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
